import Button from "@marginly/ui/components/button";
import Noop from "@marginly/ui/components/helpers/noop";
import T from "@marginly/ui/components/typography";
import copy from "copy-to-clipboard";
import React, { useCallback, useEffect, useState } from "react";
import { useAccount } from "wagmi";

import ConnectWalletModal from "@/components/navigation/connect-wallet";
import { useRx } from "@/contexts/rx";
import { useMarginlyApi } from "@/hooks/api";
import { trackBootstrapShareLinkClick } from "@/util/tracking";

import * as S from "./styled";
import { useRegister } from "./use-register";

const REFERRAL_PATH = `${window.location.host}/bootstrap/referral?code=`;

const createReferralUrl = (referralCode: string) => {
  return `${REFERRAL_PATH}${referralCode}`;
};

export function ShareLink() {
  const [connectModal, setConnectModal] = useState(false);

  const { address } = useAccount();

  const register = useRegister();

  const { data: userInfo } = useMarginlyApi({
    enabled: Boolean(address),
    endpoint: "userInfo",
    args: [address],
  });

  const [isAcceptClicked, setIsAcceptClicked] = useState(false);

  const handleShare = async () => {
    setIsAcceptClicked(true);
    trackBootstrapShareLinkClick();
    if (!address) {
      setConnectModal(true);
      return;
    }
  };

  const { notification$ } = useRx();

  const successCopy = useCallback(
    (referralCode: string) => {
      copy(createReferralUrl(referralCode));
      notification$.next({
        message: `Invite link copied`,
        imgSrc: "/images/link-invert.svg",
      });
    },
    [notification$],
  );

  useEffect(() => {
    if (isAcceptClicked && address) {
      const fetch = async () => {
        try {
          const userReferralCode = userInfo?.referralCode;
          if (!userReferralCode) {
            const { referralCode } = await register(address);
            successCopy(referralCode);
            return;
          }
          successCopy(userReferralCode);
        } finally {
          setIsAcceptClicked(false);
        }
      };
      fetch();
    }
  }, [address, isAcceptClicked, register, successCopy, userInfo?.referralCode]);

  return (
    <>
      <S.Wrapper>
        <img src="/images/airdrop/earnsparks.png" alt="" className="pic" />
        <div>
          <T body>Invite frens and earn more&nbsp;Sparks</T>
          <T caption secondary>
            Earn 10% from your frens and 5% from frens of your frens
          </T>
        </div>
        <Button sm onClick={handleShare}>
          <T action>Share Link</T>
        </Button>
      </S.Wrapper>
      {connectModal ? (
        <ConnectWalletModal onHide={() => setConnectModal(false)} />
      ) : (
        <Noop />
      )}
    </>
  );
}
